module.exports = __webpack_public_path__ + "img/logo-android.442fc8d7.svg";